export enum AccountOperationsFeatureFlags {
    AccountOperations = 'account-operations',
    AgreementAmendments = 'facility-contracts-agreement-amendments',
    HospitalSystemAccountLink = 'hospital-system-account-link',
    AmModuleAccountSearch = 'am-module-account-search',
    FacilityContractsFacilitySearch = 'facility-contracts-facility-search',
    DoNotDeleteFacilitiesWithUnits = 'do-not-delete-facilities-with-units',
    AgreementEffectiveEndDate = 'agreement-effective-end-date',
    FacilityProfileServiceInstanceLink = 'facility-profile-service-instance-link',
    FacilityProfilesLegacyServiceInstanceColumn = 'facility-profiles-legacy-service-instance-column',
    FacilityContractsServicesBillingTab = 'facility-contracts-services-billing-tab',
    TravelContractsFacilityAccountSearch = 'travel-contracts-facility-account-search',
    SecurityGroupBulkAddLocations = 'security-group-bulk-add-locations'
}
